export default {
  name: "HeroSection",

  data() {
    return ({
      hero_data: {
        kicker: "The Future of Workforce Productivity",
        headline: "Turn Social Investment Into",
        headline_accent: "Productivity Gains",
        sub_headline:
          "Infinity connects absenteeism interviews to targeted interventions, helping manufacturers solve the social issues that cripple production lines. Measure real ROI on every Rand invested.",
        btn_text: "Get Started",
        demo_text: "Watch Demo",
      },

      hero_stats: [
        { key: "absenteeism", value: "34%", label: "Average absenteeism reduction" },
        { key: "roi", value: "178%", label: "Average ROI on interventions" },
        { key: "employees", value: "12k+", label: "Employees impacted" },
        { key: "clients", value: "45+", label: "Enterprise clients" },
      ],
    });
  },

  mounted() {
    this.load_landing_page_video();
  },

  methods: {
    load_landing_page_video() {
      const video_src = getComputedStyle(document.documentElement)
        .getPropertyValue("--landing-page-video")
        .replace(/url\(|\)|"|'/g, "")
        .trim();

      if (!video_src) return;

      const video_el = document.querySelector(".landing-page-video");
      if (video_el) {
        video_el.src = video_src;
        video_el.load();
      }
    },
  },
};
